import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

/**
 * Iter-329/330 — GET /engagement/my/pending-reviews (verified live):
 *   { pending_reviews: [{ session_id, vendor_name, qr_code_id, status,
 *     review_deadline, paid_at, potential_points, … }], count }
 * One query powers the header bubble, the My-visits badges and the
 * engage paid-return banner.
 */
export function usePendingReviews(enabled = true) {
  return useQuery({
    queryKey: ["pending-reviews"],
    enabled,
    retry: 0,
    staleTime: 30_000,
    queryFn: async () =>
      (
        await sharedApi.get("/classifieds/engagement/my/pending-reviews", {
          headers: { "X-App-Platform": "nz_classified" },
          params: { platform: "nz_classified" },
        })
      ).data,
  });
}
